import jsonp from 'jsonp'
import axios from 'axios'
import globalConfig from '@utiles/officialStore/globalConfig'
import languages from '../languages'
import { convertParamToString } from '@utiles'
import { clearDisable } from '../../plugins/clickThrottling'
import qs from 'qs'

const MAIN_HOST = globalConfig.getMainHost()

export const PLATFORM_HOST = ''
export const ACHIEVEMENT_ID = 9999
export const APP_ID = 182267189223689
export const HOST = `//geventsapi.${MAIN_HOST}/`
export const PASSPORT_HOST = `//gpassport.${MAIN_HOST}/`
export const STORE_HOST = `//gstore.${MAIN_HOST}/`
export const SUPPORT_REQ_URL = `//gsupport.${MAIN_HOST}/index`
const vgmHost = ['gnjoy.hk', 'gamemart.vn', 'vgm.vn'];
export const HOME_HOST = vgmHost.includes(MAIN_HOST)
  ? `//gwww.${MAIN_HOST}/`
  : `//www.${MAIN_HOST}/`
export const H5_HOST = `//h5.${MAIN_HOST}/`
export const FUNCTION_LIST_STORE = 'functionList'
export let ERR_CODE = '0'
export const DEFAULT_LANGUAGE = (() => {
  const gameId =
    globalConfig.getHrefParam('gameId') ||
    globalConfig.getHrefParam('gameID') ||
    globalConfig.getHrefParam('game_id') || '';
  if(gameId == 2) {
    return 'ja-JP';
  }
  return 'en-US';
})();
const SUCCESS_RESULT_CODE = 1

export let appendEntryPageParams = function (params) {
  if (params.needntEntryParam) {
    return params
  }
  let entryPageParam = globalConfig.getAllWebviewEntryParams()
  return Object.assign(entryPageParam, params)
}

export let post = function (action, params, config = {}) {
  languages.init()
  if (!params['language']) {
    params['language'] = getHrefParam('language') || DEFAULT_LANGUAGE
    params['appLanguage'] = getHrefParam('appLanguage') || DEFAULT_LANGUAGE
  }
  params = appendEntryPageParams(params)
  return new Promise(resolve => {
    axios
      .post(action, qs.stringify(params), config)
      .then(function (response) {
        clearDisable()
        let res = response.data
        if (SUCCESS_RESULT_CODE != res.result) {
          let errmsg =
            (res && res.msg && res.msg.replace(/\[\-\d*\]/, '')) || ''
          errmsg = languages.get(res.code) || errmsg
          resolve({
            errmsg: errmsg,
            data: [],
            res: res
          })
        } else {
          resolve({
            errmsg: '',
            data: res.data,
            res: res
          })
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  })
}

export let getJSON = function (action, params) {
  if (!params.notNeedInitLanguage) {
    languages.init()
  }
  if (!params['language']) {
    params['language'] = getHrefParam('language') || DEFAULT_LANGUAGE
    params['appLanguage'] = getHrefParam('appLanguage') || DEFAULT_LANGUAGE
  }
  if (params.notNeedInitLanguage) {
    delete params.notNeedInitLanguage
  }
  try {
    let roleName = params['roleName']
    if (roleName && /[\#\&\?]/.test(roleName)) {
      params['roleName'] = encodeURIComponent(roleName)
    }
  } catch (e) {}
  params = appendEntryPageParams(params)
  if (typeof window != 'undefined') {
    return getJSONP(action, params)
  } else {
    return get(action, params)
  }
}

export let getJSONWithoutEntryParam = function (action, params) {
  languages.init()
  if (!params['language']) {
    params['language'] = getHrefParam('language') || DEFAULT_LANGUAGE
    params['appLanguage'] = getHrefParam('appLanguage') || DEFAULT_LANGUAGE
  }
  if (typeof window != 'undefined') {
    return getJSONP(action, params)
  } else {
    return get(action, params)
  }
}

export let get = function (action, params) {
  return new Promise(resolve => {
    axios
      .get(action, {
        params
      })
      .then(function (response) {
        clearDisable()
        let res = response.data
        if (SUCCESS_RESULT_CODE != res.result) {
          let errmsg =
            (res && res.msg && res.msg.replace(/\[\-\d*\]/, '')) || ''
          errmsg = languages.get(res.code) || errmsg
          resolve({
            errmsg: errmsg,
            data: [],
            res: response
          })
        } else {
          resolve({
            errmsg: '',
            data: res.data,
            res: res
          })
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  })
}

let getJSONP = function (action, params) {
  return new Promise(resolve => {
    let paramStr = convertParamToString(params || {})
    jsonp(
      action,
      {
        prefix: 'jsonpCallback',
        param: paramStr
      },
      (err, response) => {
        clearDisable()
        if (err || SUCCESS_RESULT_CODE != response.result) {
          let errmsg =
            response && response.msg && response.msg.replace(/\[\-\d*\]/, '')
          errmsg = response ? languages.get(response.code) || errmsg : errmsg
          resolve({
            errmsg: errmsg,
            data: [],
            res: response
          })
        } else {
          resolve({
            errmsg: '',
            data: response.data,
            res: response
          })
        }
      }
    )
  })
}

export let getHrefParam = function (paramName) {
  return globalConfig.getHrefParam(paramName)
}

export const loadConverstData = function (loadData, map) {
  let result = {}
  for (let key in map) {
    let mapKey = map[key]
    let val = loadData[mapKey] || ''
    result[key] = val
  }
  return result
}

export let getGameId = function () {
  return getHrefParam('game_id') || getHrefParam('gameid')
}

export const formatTextAreaVal = function (inputVal) {
  // 匹配换行符==> <br/>，空白字符==>&nbsp;
  return inputVal.replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
}

export let getShareContent = function (config, action) {
  return new Promise(resolve => {
    post(action, {
      achievementId: config.achievementId,
      appId: APP_ID,
      gameId: getGameId(),
      serverId: config.serverId,
      fbid: config.fbid || '',
      loginAccount: config.name,
      timestamp: new Date().getTime(),
      roleId: config.roleId,
      roleName: config.roleName,
      devicePlate: 'pc',
      pic: ''
    }).then(({ errmsg, data }) => {
      if (errmsg) {
        resolve({
          link: '',
          token: '',
          errmsg: errmsg
        })
      } else {
        resolve({
          link: data.LINK,
          token: data.TOKEN,
          errmsg: ''
        })
      }
    })
  })
}

let formatTimeBit = function (time) {
  if (time < 10) {
    time = '0' + time
  }
  return time
}

// 得到标准时区的时间的函数
export let getLocalTime = function (i, timestamp) {
  // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
  if (typeof i !== 'number') return
  let d = new Date()
  // 得到1970年一月一日到现在的秒数
  let len = d.getTime(timestamp)
  // 本地时间与GMT时间的时间偏移差
  let offset = d.getTimezoneOffset() * 60000
  // 得到现在的格林尼治时间
  let utcTime = len + offset
  return new Date(utcTime + 3600000 * i)
}
export let mapDateTime = function (time) {
  let date = getLocalTime(9, time)
  return (
    date.getFullYear() +
    '-' +
    formatTimeBit(date.getMonth() + 1) +
    '-' +
    formatTimeBit(date.getDate())
  )
}
// 倒计时
export let countDown = function (seconds) {
  let allSeconds = seconds
  let remainSecond = allSeconds % 60 // 取餘，剩下的秒數
  let allMinute = parseInt(allSeconds / 60) // 總共有多少分鐘
  let allHour = parseInt(allMinute / 60) // 總共有多少個小時
  let remainMinute = allMinute - allHour * 60
  let remainHour = allHour

  remainSecond = remainSecond < 10 ? '0' + remainSecond : remainSecond
  remainMinute = remainMinute < 10 ? '0' + remainMinute : remainMinute
  remainHour = remainHour < 10 ? '0' + remainHour : remainHour

  return remainHour + ':' + remainMinute + ':' + remainSecond
}
